const KEY = 'ba-family-prefill';
export function prepareFamilyPrefill(parentName, email, eventTag) {
  try { sessionStorage.setItem(KEY, JSON.stringify({ firstName: String(parentName || '').trim().split(/\s+/)[0] || '', email: email || '', eventTag, until: Date.now() + 10 * 60 * 1000 })); } catch { /* Family page can still be completed by hand. */ }
}
export function consumeFamilyPrefill(eventTag) {
  try {
    const value = JSON.parse(sessionStorage.getItem(KEY));
    sessionStorage.removeItem(KEY);
    return value?.until > Date.now() && value.eventTag === eventTag ? value : {};
  } catch { return {}; }
}
